import { Link } from 'react-router-dom';

export type BreadCrumbItemProps = React.HTMLAttributes<HTMLLIElement> & {
	label: string;
	url?: string;
	active?: boolean;
};

export const BreadCrumbItem: React.FC<BreadCrumbItemProps> = ({
	label,
	url,
	active,
	className,
	...props
}) => {
	return (
		<li
			className={`breadcrumb-item text-truncate header-bread-crumb-bread-crumb-item${
				active ? ' active' : ''
			}${className ? ` ${className}` : ''}`}
			{...props}
		>
			{url ? <Link to={url}>{label}</Link> : label}
		</li>
	);
};
